<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-form :model="user" :rules="rules" ref="user" label-width="100px" class="user-form" size="mini">
                    <el-form-item label="用户名" prop="userName">
                        <el-input v-model="user.userName" :disabled="isDisabled"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="userRealName">
                        <el-input v-model="user.userRealName"></el-input>
                    </el-form-item>
                    <el-form-item label="角色" prop="roleCode">
                        <el-select v-model="user.roleCode" filterable placeholder="请选择">
                            <el-option
                            v-for="item in roles"
                            :key="item.roleCode"
                            :label="item.roleName"
                            :value="item.roleCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phoneNo">
                        <el-input v-model="user.phoneNo" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="user.email"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="userStatus">
                        <el-select v-model="user.userStatus" filterable placeholder="请选择">
                            <el-option
                            v-for="item in dataStatuses"
                            :key="item.dictCode"
                            :label="item.dictDesc"
                            :value="item.dictCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="外部账号" prop="outAccount">
                        <el-input v-model="user.outAccount"></el-input>
                    </el-form-item>
                    <el-form-item label="缩略名" prop="shortName">
                        <el-input v-model="user.shortName"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input v-model="user.remark"></el-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row class="row-button">
            <el-button type="primary" @click="submitForm('user')">提交</el-button>
            <el-button @click="cancel">取消</el-button>
        </el-row>
    </div>
</template>

<script>
import GlobeConstant from '../../../assets/js/GlobeConstant';

    export default {
    name: "UserUpdate",
    props: ["userProp"],
    components: {
    },
    data() {
        var validatePhoneNo = (rule, value, callback) => {
            if(value === '' || value === null ) {
                callback();
            } else {
                let reg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
                if(!reg.test(value)) {
                    callback(new Error("请输正确的手机号"));
                }
            }
            callback();
        };  

        return {
            user: {
                userName: "",
                realName: "",
                userType: "",
                teamId: "",
            },
            rules: {
                userName: [
                    { required: true, message: "请输入用户名", trigger: "blur" },
                    { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
                ],
                userRealName: [
                    { required: true, message: "请输入真实姓名", trigger: "blur" },
                    { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
                ],
                phoneNo: [
                    { validator: validatePhoneNo, trigger: "blur" }
                ],
                roleCode: [
                    { required: true, message: "请选择角色", trigger: "change" }
                ],
                email: [
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                ],
                shortName: [
                    { required: true, message: "请输入缩略名", trigger: "blur" },
                    { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
                ],
            },
            dictTypeUserType: "user_type",
            dictTypeTeam: "team",
            isDisabled: false,
            roles:[],
            restaurants: [],
            state: '',
            timeout:  null,
            dataStatuses: [],
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/user/save", this.user).then(res => {
                        if (res.data.status === "success") {
                            this.$message({
                                message: "提交成功！",
                                type: "success"
                            });
                            this.$bus.$emit(GlobeConstant.userupdate_to_user_close);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }, error => {
                        this.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
        },
        cancel() {
            this.$bus.$emit(GlobeConstant.userupdate_to_user_close);
        },
        queryAll() {
             this.$axios.post("/role/findAll").then(
                res=>{
                    if(res.data.status === "success"){
                        this.restaurants = res.data.result;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        querySearchAsync(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
            cb(results);
            }, 3000 * Math.random());
        },
        createStateFilter(queryString) {
            return (state) => {
            return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        loadAll() {
            this.$axios.post("/role/findAll").then(
                res=>{
                    if(res.data.status === "success"){
                        this.restaurants = res.data.result;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        queryUserStatus() {
            let condition = {value:"DATA_STATUS"};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        this.dataStatuses = res.data.result;
                    }else {
                            this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        queryRoles() {
            this.$axios.post("/role/findAll").then(
                res=>{
                    if(res.data.status === "success"){
                        this.roles = res.data.result;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        }
    },
    created() {
        this.user = this.userProp;
        if (this.userProp.id) {
            this.isDisabled = true;
        } else {
            this.isDisabled = false;
        }
        this.loadAll();
        this.queryUserStatus();
        this.queryRoles();
    },
}


</script>

<style scoped>

   .user-form {
       margin: 20px 20px 20px 20px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }
   .el-select {
        width: 100%;
    }
    .row-button {
        display: flex;
        justify-content: right;
        border-top: solid 1px;
   }

   .row-button >.el-button {
        margin-top: 10px;
        margin-right: 10px;
   }

</style>
